export default {"src":"/_next/static/media/tiktok-footer.2b6d0f2c.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};